// material ui
import { alpha, Theme } from '@mui/material';

export const toggleButtonCustomization = () => ({
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        display: 'inline-flex',
        gap: 4,
        padding: 2,
        borderRadius: '6px',
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[900]
            : theme.palette.grey[100],
        border:
          theme.palette.mode === 'dark'
            ? '1px solid #30363d'
            : '1px solid #e1e4e8',
      }),
      grouped: {
        margin: 0,
        border: 'none',
        borderRadius: '6px !important',
      },
    },
  },
  MuiToggleButton: {
    defaultProps: {
      disableElevation: true,
      disableRipple: true,
    },
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        textTransform: 'none',
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: '18px',
        padding: '6px 16px',
        border: 'none',
        color: theme.palette.mode === 'dark' ? '#8b949e' : '#656d76',
        backgroundColor: 'transparent',
        transition: '0.2s cubic-bezier(0.3, 0, 0.5, 1)',
        transitionProperty: 'color, background-color, box-shadow',
        '&:hover': {
          backgroundColor:
            theme.palette.mode === 'dark'
              ? alpha('#ffffff', 0.06)
              : alpha('#000000', 0.04),
          color: theme.palette.mode === 'dark' ? '#c9d1d9' : '#24292f',
        },
        '&.Mui-selected': {
          color: theme.palette.mode === 'dark' ? '#e6edf3' : '#24292f',
          fontWeight: 600,
          backgroundColor:
            theme.palette.mode === 'dark'
              ? theme.palette.grey[700]
              : theme.palette.grey[0],
          boxShadow:
            theme.palette.mode === 'dark'
              ? '0 1px 2px rgba(0, 0, 0, 0.6)'
              : '0 1px 2px rgba(27, 31, 35, 0.12)',
          '&:hover': {
            backgroundColor:
              theme.palette.mode === 'dark'
                ? theme.palette.grey[700]
                : theme.palette.grey[0],
          },
        },
        '&.Mui-focusVisible': {
          boxShadow:
            theme.palette.mode === 'dark'
              ? `0 0 0 3px ${alpha('#2f81f7', 0.35)}`
              : `0 0 0 3px ${alpha('#0969da', 0.25)}`,
        },
        '&.Mui-disabled': {
          color:
            theme.palette.mode === 'dark'
              ? alpha('#c9d1d9', 0.25)
              : alpha('#24292f', 0.2),
          border: 'none',
          backgroundColor: 'transparent',
        },
      }),
    },
  },
});
